import React from 'react';
import styles from './svg.css';

const PoweredByVFC = () => (
  <svg
    version="1.1"
    className={styles.poweredByVFC}
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 734.15 266.05"
  >
    <title>Covetrus_White</title>
    <g>
      <path
        className="st0"
        d="M252.72,233.56c0-20.8,16.09-36.77,37-36.77,16.36,0,28.92,9,34.41,22.38l-16.61,6.67A18.2,18.2,0,0,0,290,213.67c-10.85,0-19.36,8.9-19.36,19.89a19.57,19.57,0,0,0,19.5,19.62c8.37,0,14.65-5.1,17.53-12.3l16.88,6.94c-6,13.08-17.8,22.5-34.68,22.5C268.68,270.32,252.72,254.1,252.72,233.56Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M330.91,233.56c0-20.41,16.09-36.77,37.29-36.77s37.42,16.36,37.42,36.77-16.1,36.76-37.42,36.76S330.91,253.84,330.91,233.56Zm56.78-.13a19.37,19.37,0,1,0-19.36,19.75A19.49,19.49,0,0,0,387.69,233.43Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M405,198.23h19.1l17.4,47.63L459,198.23h18.7L450,268.88H432Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M478.93,233.69a36.48,36.48,0,0,1,37-36.9c21.19,0,36.5,15.31,36.5,36.24v6.81H496.33c2.36,9.16,9.82,14.91,20.28,14.91,8.38,0,14-3.66,17.54-9.42L548.93,254c-7.06,9.94-17,16.35-32.58,16.35C493.59,270.32,478.93,254.23,478.93,233.69Zm17.93-8h37.68c-2.36-8.77-9.16-13.61-18.58-13.61A19.65,19.65,0,0,0,496.86,225.71Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M557.17,198.23h13.09V182.92l17.79-10.46v25.77h18.58v16H588.05v29c0,7.46,3.14,10.07,7.72,10.07a9.28,9.28,0,0,0,6.54-2.61l8.25,14.13a28,28,0,0,1-16.88,5.36c-14.79,0-23.42-7.06-23.42-26.3V214.2H557.17Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M622.38,198.23h17.79v10.86c3.41-8.37,10.47-12.16,19.5-12.16a26.2,26.2,0,0,1,11.9,2.74L665,217.47c-2-1.44-5.36-2.49-9.42-2.49-9.29,0-15.3,4.71-15.3,16.62v37.28H622.38Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M677.46,240.62V198.23h18.45v39.91c0,9.94,4.71,16.09,14.39,16.09,8.51,0,14.78-6.15,14.78-17.14V198.23l18.32-.13v70.65l-18,.13V260a24.51,24.51,0,0,1-20.41,10.33C687.53,270.32,677.46,259.2,677.46,240.62Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M754.66,252.79l17.4-6.8c3.14,6.28,8.76,9.55,16.22,9.55s11.25-3.53,11.25-7.72c0-5.1-7.59-6.28-16.61-8.11-11.91-2.49-25.12-6.15-25.12-21.07,0-11.9,11.51-22.24,28.91-22.11,14.91,0,23.81,5.63,30.35,15.05l-16.48,6.67c-2.88-4.71-7.33-7.46-13.87-7.46-7.07,0-10.47,2.88-10.47,6.81,0,4.45,5.76,5.62,16.1,7.85C804.11,227.8,818,231.86,818,247c0,11-9.81,23.42-30.35,23.29C770.88,270.32,760.28,264,754.66,252.79Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M981.42,288.06a10.71,10.71,0,0,1,4,4,11.6,11.6,0,0,1,0,11.23,10.79,10.79,0,0,1-4,4,11.46,11.46,0,0,1-11.23,0,10.72,10.72,0,0,1-4-4,11.55,11.55,0,0,1,0-11.24,10.66,10.66,0,0,1,4-4,11.59,11.59,0,0,1,11.26,0Zm-.73,18.05a9.27,9.27,0,0,0,3.45-3.5,9.89,9.89,0,0,0,1.26-5,9.76,9.76,0,0,0-1.26-4.91,9.29,9.29,0,0,0-3.45-3.48,10,10,0,0,0-9.81,0,9.27,9.27,0,0,0-3.47,3.48,9.85,9.85,0,0,0-1.25,4.91,10,10,0,0,0,1.25,5,9.26,9.26,0,0,0,3.47,3.5,10.11,10.11,0,0,0,9.81,0Zm-1.12-5.91,2.39,4h-2.55L977,300a2.33,2.33,0,0,0-.8-.82,2.36,2.36,0,0,0-1.1-.23h-1.63v5.25h-2.27v-13.1h5.46a5,5,0,0,1,3.36,1,3.61,3.61,0,0,1,1.18,2.87,3.69,3.69,0,0,1-.87,2.51,4,4,0,0,1-2.47,1.24A3.05,3.05,0,0,1,979.57,300.2Zm-1.29-3.51a2,2,0,0,0,.61-1.59,2,2,0,0,0-.61-1.64,3.06,3.06,0,0,0-1.93-.5h-2.92v4.23h2.92A3.06,3.06,0,0,0,978.28,296.69Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M282.38,404a29.31,29.31,0,0,1-14.91-3.63,24.56,24.56,0,0,1-9.7-10.21,37.06,37.06,0,0,1,.11-31.25,25.63,25.63,0,0,1,9.93-10.49A29.51,29.51,0,0,1,283,344.68a34.55,34.55,0,0,1,11.45,1.93,23.48,23.48,0,0,1,9.08,5.44L300,360.33a31.14,31.14,0,0,0-8-4.76,22.17,22.17,0,0,0-8.22-1.59q-8.16,0-12.87,5.33t-4.71,15.2q0,9.87,4.65,15.08t12.93,5.22a22.38,22.38,0,0,0,8.17-1.59,30.88,30.88,0,0,0,8-4.76l3.52,8.28a25.32,25.32,0,0,1-9.3,5.33A36.62,36.62,0,0,1,282.38,404Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M338.07,404a29.1,29.1,0,0,1-14.8-3.63,24.42,24.42,0,0,1-9.7-10.27,38.11,38.11,0,0,1,0-31.47,24.37,24.37,0,0,1,9.7-10.32,31.76,31.76,0,0,1,29.49,0,24.79,24.79,0,0,1,9.75,10.32,37.51,37.51,0,0,1,0,31.47,24.84,24.84,0,0,1-9.75,10.27A28.91,28.91,0,0,1,338.07,404Zm0-9.08q7.71,0,12-5.21t4.26-15.43q0-9.87-4.26-15.14t-12-5.27q-7.71,0-12.08,5.27t-4.37,15.14q0,10.22,4.26,15.43T338.07,394.92Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M378.44,403.2V362.14c0-2.64-.05-5.33-.17-8.05s-.36-5.4-.73-8h10.89l1,11.57-1.14.45a19.28,19.28,0,0,1,7.15-9.87,20.14,20.14,0,0,1,11.91-3.51q8.16,0,12.76,4t5.95,12.41l-2.72-1.92a19.09,19.09,0,0,1,7.43-10.61,21.77,21.77,0,0,1,13-3.91q9.53,0,14.29,5.73t4.77,17.29v35.5H451.37v-35q0-7.38-2.55-10.78T440.6,354a12.8,12.8,0,0,0-10.38,4.54q-3.8,4.53-3.8,12.36V403.2H415v-35q0-7.38-2.61-10.78c-1.74-2.27-4.47-3.4-8.17-3.4q-6.69,0-10.49,4.54t-3.8,12.36V403.2Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M478.36,427.7V362.14c0-2.64-.05-5.33-.17-8.05s-.36-5.4-.73-8h10.89l1,11.57-.8,1.25a18.32,18.32,0,0,1,7.32-10.5,22.28,22.28,0,0,1,12.87-3.68A23.64,23.64,0,0,1,522,348.42a25.23,25.23,0,0,1,9,10.49,35.93,35.93,0,0,1,3.24,15.71,35.22,35.22,0,0,1-3.24,15.6A23.46,23.46,0,0,1,508.76,404a22.21,22.21,0,0,1-12.87-3.69,18.3,18.3,0,0,1-7.32-10.49l1.25-1.36V427.7Zm27.79-32.78q7.71,0,12-5.27t4.31-15q0-9.75-4.31-15.25t-12-5.5q-7.93,0-12.13,5.33t-4.2,15.19q0,9.87,4.2,15.2T506.15,394.92Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M571.37,404a29.1,29.1,0,0,1-14.8-3.63,24.42,24.42,0,0,1-9.7-10.27,38.11,38.11,0,0,1,0-31.47,24.37,24.37,0,0,1,9.7-10.32,31.74,31.74,0,0,1,29.48,0,24.75,24.75,0,0,1,9.76,10.32,37.51,37.51,0,0,1,0,31.47,24.8,24.8,0,0,1-9.76,10.27A28.85,28.85,0,0,1,571.37,404Zm0-9.08q7.71,0,12-5.21t4.26-15.43q0-9.87-4.26-15.14t-12-5.27q-7.73,0-12.08,5.27t-4.37,15.14q0,10.22,4.25,15.43T571.37,394.92Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M632.16,404q-10.32,0-15.54-5.73t-5.22-17.18V346h11.46V381q0,7,2.89,10.38t8.9,3.35a14.61,14.61,0,0,0,11.17-4.54q4.26-4.53,4.26-12V346h11.45V403.2H650.42V391.07l1.36-.46a19.28,19.28,0,0,1-7.6,10A21.52,21.52,0,0,1,632.16,404Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M677.3,403.2V362.14c0-2.64-.06-5.33-.17-8.05s-.36-5.4-.74-8h10.89l1,11.57-1.14.68a19.72,19.72,0,0,1,8-10.15,23.22,23.22,0,0,1,12.65-3.46q20.52,0,20.52,23v35.5H716.88v-35q0-7.38-2.89-10.78t-9.13-3.4q-7.38,0-11.74,4.54t-4.37,12.13V403.2Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M796.16,403.2H784.82v-15l1.36,1.59a18.3,18.3,0,0,1-7.32,10.49,22.41,22.41,0,0,1-13,3.69,23.86,23.86,0,0,1-13.22-3.69,24.42,24.42,0,0,1-8.9-10.43,36.81,36.81,0,0,1-3.18-15.83,35.89,35.89,0,0,1,3.12-15.53,23.84,23.84,0,0,1,8.85-10.21,24.36,24.36,0,0,1,13.33-3.63,22.22,22.22,0,0,1,13,3.74,18.57,18.57,0,0,1,7.32,10.44l-1.48,1.36V319.73h11.46Zm-27.56-8.28q7.71,0,12-5.33t4.26-15.31q0-9.64-4.26-15t-12-5.38q-7.83,0-12.19,5.27T752,374.05q0,10,4.37,15.43T768.6,394.92Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M811.24,321.09h13.27v12H811.24Zm.8,82.11V346h11.45V403.2Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M839.37,403.2V362.14c0-2.64-.06-5.33-.17-8.05s-.36-5.4-.74-8h10.89l1,11.57-1.13.68a19.65,19.65,0,0,1,8-10.15,23.22,23.22,0,0,1,12.65-3.46q20.52,0,20.53,23v35.5H879v-35q0-7.38-2.89-10.78t-9.13-3.4q-7.38,0-11.74,4.54t-4.37,12.13V403.2Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M931.46,428.49q-13,0-22.79-5.67l1.81-9a51.34,51.34,0,0,0,10.21,4.2,39.42,39.42,0,0,0,10.66,1.36q7.93,0,12-4.08t4.08-12.25V388.23l1.25-.79a20.62,20.62,0,0,1-4.25,7.31,19.48,19.48,0,0,1-7,5,23.29,23.29,0,0,1-9.25,1.76A24,24,0,0,1,905.89,388a35.95,35.95,0,0,1,0-29.83,24,24,0,0,1,22.28-13.49,22.71,22.71,0,0,1,13.16,3.74,18.42,18.42,0,0,1,7.37,10.44l-1.36-.57V346H958.8v56q0,13.15-6.92,19.79T931.46,428.49Zm-.57-36.18q7.73,0,12.08-5.1T947.34,373q0-8.85-4.37-14t-12.08-5.16q-7.82,0-12.3,5.1T914.11,373q0,9.08,4.48,14.18T930.89,392.31Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M851.37,201.69v65.05L909,234.21Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M854.43,271.79,915,306l60.58-34.19L915,237.6Z"
        transform="translate(-252.72 -162.45)"
      />
      <path
        className="st0"
        d="M854.43,196.64,915,230.82l60.58-34.18L915,162.45Z"
        transform="translate(-252.72 -162.45)"
      />
    </g>
    <g>
      <path
        className="st0"
        d="M6.2,26.7V9.3h2.3v1.8C9.5,9.8,11,9,12.6,9c3.3,0,5.6,2.5,5.6,6.6s-2.3,6.6-5.6,6.6c-1.6,0-3.1-0.8-4.1-2.1v6.6
    H6.2z M12.1,11.1c-1.4,0-2.7,0.7-3.5,1.9v5.3c0.8,1.1,2.1,1.8,3.5,1.9c2.3,0,3.8-1.9,3.8-4.5S14.4,11.1,12.1,11.1z"
      />
      <path
        className="st0"
        d="M20.5,15.6c-0.2-3.5,2.4-6.4,5.9-6.6h0.5c3.9,0,6.3,3,6.3,6.6s-2.4,6.6-6.3,6.6c-3.5,0.1-6.3-2.7-6.4-6.2
    C20.5,15.9,20.5,15.7,20.5,15.6z M30.7,15.6c0-2.4-1.4-4.5-3.9-4.5s-3.9,2.1-3.9,4.5s1.4,4.5,3.9,4.5S30.7,18,30.7,15.6z"
      />
      <path
        className="st0"
        d="M43.9,12.2l-3.1,9.7h-2.4l-4-12.6h2.5l2.9,9.6l3.1-9.6h2l3.2,9.6L51,9.3h2.4l-4,12.6H47L43.9,12.2z"
      />
      <path
        className="st0"
        d="M61,9c3.8,0,6.1,2.9,6.1,6.8v0.6h-10c0.1,2.3,2,4,4.3,3.9c1.4,0,2.7-0.5,3.7-1.5l1.1,1.5
    c-1.4,1.2-3.2,1.9-5,1.9c-3.5,0.1-6.4-2.5-6.5-6v-0.6c-0.2-3.5,2.5-6.4,5.9-6.6c0,0,0,0,0.1,0L61,9z M57.2,14.7h7.7
    c0-2.1-1.6-3.8-3.7-3.8h-0.1C59,10.8,57.2,12.5,57.2,14.7C57.2,14.6,57.2,14.7,57.2,14.7z"
      />
      <path
        className="st0"
        d="M70,9.3h2.3v1.9c1-1.3,2.5-2.1,4.1-2.2v2.4c-0.3-0.1-0.5-0.1-0.8-0.1c-1.3,0.1-2.5,0.8-3.3,1.8v8.7H70V9.3z"
      />
      <path
        className="st0"
        d="M84.3,9c3.8,0,6.1,2.9,6.1,6.8v0.6h-9.9c0.1,2.3,2,4,4.3,3.9c1.4,0,2.7-0.5,3.7-1.5l1.1,1.5
    c-1.4,1.2-3.2,1.9-5,1.9c-3.5,0.1-6.4-2.5-6.5-6v-0.6C77.9,12.1,80.6,9.2,84,9c0,0,0,0,0.1,0L84.3,9z M80.5,14.7h7.7
    c0-2-1.6-3.7-3.6-3.7c0,0-0.1,0-0.1,0h-0.1c-2-0.1-3.8,1.4-3.9,3.5C80.5,14.5,80.5,14.6,80.5,14.7z"
      />
      <path
        className="st0"
        d="M102.3,20.1c-1,1.3-2.5,2.1-4.1,2.1c-3.3,0-5.6-2.5-5.6-6.6S94.9,9,98.2,9c1.6,0,3.1,0.8,4.1,2.1V4.5h2.3v17.3
    h-2.3V20.1z M102.3,12.9c-0.8-1.1-2.1-1.8-3.5-1.9c-2.3,0-3.8,1.9-3.8,4.5s1.5,4.5,3.8,4.5c1.4,0,2.7-0.7,3.5-1.8V12.9z"
      />
      <path
        className="st0"
        d="M115.1,4.5h2.3v6.6c1-1.3,2.5-2.1,4.1-2.1c3.3,0,5.6,2.6,5.6,6.6s-2.3,6.6-5.6,6.6c-1.6,0-3.1-0.8-4.1-2.1v1.8
    h-2.3V4.5z M120.9,20.1c2.3,0,3.8-1.9,3.8-4.5s-1.5-4.5-3.8-4.5c-1.4,0-2.7,0.7-3.5,1.9v5.3C118.2,19.4,119.5,20.1,120.9,20.1z"
      />
      <path
        className="st0"
        d="M130.9,24.9c0.8,0.1,1.6-0.4,1.8-1.2l0.7-1.7l-5.2-12.7h2.5l3.9,9.9l3.9-9.9h2.5l-6.2,15
    c-0.6,1.7-2.2,2.8-4,2.7c-0.5,0-1-0.1-1.5-0.2l0.4-2.1C130.1,24.8,130.5,24.9,130.9,24.9z"
      />
    </g>
  </svg>
);

export default PoweredByVFC;



// WEBPACK FOOTER //
// ./src/assets/PoweredByVFC.jsx